export default __webpack_public_path__ + "57eac301c3cd4a0546593d3019e6e149.png";